import { clientInstance } from "../config/config";

export let createQuizAPI = async (quizData) => {
    return clientInstance.post(`/quiz`, quizData);
}

export let getQuizAPI = async (quizId) => {
    return clientInstance.get(`/quiz/${quizId}`);
}

export let getMyQuizzesAPI = async () => {
    return clientInstance.get(`/quiz/my`);
}

export let getStudentQuizzesAPI = async () => {
    return clientInstance.get(`/quiz/student`);
}

export let updateQuizAPI = async (quizId, quizData) => {
    return clientInstance.put(`/quiz/${quizId}`, quizData);
}

export let deleteQuizAPI = async (quizId) => {
    return clientInstance.delete(`/quiz/${quizId}`);
}

export let assignQuizAPI = async (quizId, studentId) => {
    return clientInstance.post(`/quiz/${quizId}/assign`, { studentId });
}

export let getQuizResultsAPI = async (quizId) => {
    return clientInstance.get(`/quiz/${quizId}/results`);
}

